<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        车辆报警明细
        <template slot="operate">
          <!-- <el-button
                      class="g-form-section-search operate__item"
                      icon="e6-icon-set-up_line"
                      type="primary"
                      title="自定义列设置"
                      @click="handleExport"
                    ></el-button> -->
          <!-- <el-button
                      class="g-form-section-search operate__item"
                      icon="e6-icon-export_line"
                      type="primary"
                      title="导出"
                      @click="handleExport"
                    ></el-button> -->

          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.alarmStartRange">
            <el-date-picker
              v-model="slotForms.forms.alarmStartRange"
              type="datetimerange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="datePickerOptions"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.comparyName">
            <el-input
              v-model="slotForms.forms.comparyName"
              placeholder="企业名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.alarmNameType">
            <el-select
              v-model="slotForms.forms.alarmNameType"
              clearable
              filterable
              placeholder="报警名称"
            >
              <el-option
                v-for="item in alarmNameOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.alarmStatus">
            <el-select
              v-model="slotForms.forms.alarmStatus"
              clearable
              filterable
              placeholder="报警状态"
            >
              <el-option
                v-for="item in alarmStatusOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
      >
        <div slot="empty" class="figure-data">
          <div class="nodate">
            <img src="../../assets/images/pg-nodata.png" alt="" />
          </div>
        </div>
        <el-table-column
          label="序号"
          width="60"
          header-align="center"
          align="center"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          label="所属企业"
          min-width="170"
          fixed
          header-align="center"
          align="left"
          prop="comparyName"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="车牌号"
          min-width="100"
          header-align="center"
          align="left"
          :show-overflow-tooltip="true"
          prop="vehicleNum"
        ></el-table-column>
        <el-table-column
          label="监测点"
          min-width="130"
          header-align="center"
          align="right"
          prop="uuid"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="报警名称"
          min-width="100"
          header-align="center"
          :show-overflow-tooltip="true"
          align="center"
          prop="alarmName"
        ></el-table-column>
        <el-table-column
          label="报警状态"
          min-width="80"
          header-align="center"
          :show-overflow-tooltip="true"
          align="center"
          prop="alarmStatusName"
        ></el-table-column>
        <el-table-column
          label="开始时间"
          min-width="140"
          header-align="center"
          :show-overflow-tooltip="true"
          align="center"
          prop="alarmStartTime"
        ></el-table-column>
        <el-table-column
          label="结束时间"
          min-width="140"
          header-align="center"
          :show-overflow-tooltip="true"
          align="center"
          prop="alarmEndTime"
        ></el-table-column>
        <el-table-column
          label="持续时间"
          min-width="140"
          header-align="center"
          :show-overflow-tooltip="true"
          align="left"
          prop="alarmSpaceTime"
        ></el-table-column>
        <el-table-column
          label="报警开始地点"
          min-width="200"
          header-align="center"
          align="left"
          prop="alarmBeginPlace"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="报警结束地点"
          min-width="200"
          header-align="center"
          align="left"
          prop="alarmEndPlace"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="报警详细信息"
          min-width="250"
          header-align="center"
          align="left"
          prop="alarmMsgData"
          :show-overflow-tooltip="true"
        ></el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
  </div>
</template>

<script>
import {
  FetchVehicleFindByPage,
  getAlarmTypeData,
  exportListByVehicle,
} from "@/api/alarm/comparyAlarm";
import { mapGetters, mapActions } from "vuex";
import resizeListener from "_private/mixins/resizeListener";

import operationManage from "_private/mixins/operationManage";
import { mergeFormExtend } from "_private/utils/merge";
import { datePickerOptionsNotContainToday } from "@/utils/dateUtil.js";
import { exportXlsx } from "@/utils/exportXlsx.js";
import moment from "moment";

export default {
  mixins: [resizeListener, operationManage],
  data() {
    return {
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: false,
      formExtend: {
        forms: {
          alarmStartRange: [],
          comparyName: "",
          alarmNameType: "",
          alarmStatus: "",
        },
        extends: [],
      },
      formsExtend: [],
      alarmNameOption: [],
      alarmStatusOption: [
        {
          label: "已结束",
          value: 1,
        },
        {
          label: "未结束",
          value: 2,
        },
      ],
      tableData: [],
      loading: "false",
      datePickerOptions: datePickerOptionsNotContainToday,

      //导出URL
      exportUrl: "/report/vehicle/info/exportVehicleAlarmInfo?",
    };
  },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"]),
  },
  created() {
    // 条件查询时间范围恢复默认值-今天
    let beginTime =
      Number(this.$route.query.beginTime) ||
      moment().subtract(1, "day").startOf("day").toDate();
    let endTime =
      Number(this.$route.query.endTime) ||
      moment().subtract(1, "day").endOf("day").toDate();
    this.formExtend.forms.comparyName = this.$route.query.comparyName;
    this.formExtend.forms.alarmStartRange = [
      moment(beginTime).startOf("day").format("YYYY-MM-DD HH:mm:ss"),

      moment(endTime).endOf("day").format("YYYY-MM-DD HH:mm:ss"),
    ];
    // 报警类型下拉列表
    this.getAlarmType();
    this.FetchFindByPage(this.mergeObj());
    this.setSearchFormIsOpenAct();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 检验时间40天
    validataTime() {
      let start = moment(this.formExtend.forms.alarmStartRange[0]);
      let end = moment(this.formExtend.forms.alarmStartRange[1]);
      //判断时间间隔不能大于40天
      if (end.diff(start, "days") > 39) {
        this.$message.warning("开始时间与结束时间间隔不能大于40天！");
        return false;
      } else {
        return true;
      }
    },
    // 获取下拉列表
    getAlarmType() {
      getAlarmTypeData().then((res) => {
        let tempStr = res.substring(1, res.length - 1);
        tempStr = tempStr.replace(/[\r\n]/g, "");
        let tempArr = tempStr.split(",");
        this.alarmNameOption = tempArr.map((item) => {
          let value = item.split(":")[0];
          let label = item.split(":")[1];
          return {
            value: Number(value),
            label: label.substring(1, label.length - 1),
          };
        });
      });
    },
    // 获取表格数据
    FetchFindByPage(response) {
      if (!response.alarmStartRange) {
        this.$message.warning("开始时间与结束时间不能为空！");
        return false;
      }
      if (this.validataTime()) {
        this.loading = true;
        FetchVehicleFindByPage(response)
          .then((response) => {
            if (
              response.result &&
              response.result.data &&
              Array.isArray(response.result.data)
            ) {
              this.tableData = response.result.data;
              this.total = response.result.totalRecords;
            }
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            console.log(error);
          });
      }
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize,
        },
        userId: 1,
      });
    },
    // 导出excel 表格
    handleExport() {
      if (this.validataTime()) {
        let params = this.mergeObj();
        this.exportData(params);
      }
    },
    // 导出页面数据接口请求
    async exportData(params) {
      try {
        exportListByVehicle(params).then((res) => {
          // 导出
          exportXlsx(res, `车辆报警明细.xls`);
        });
      } catch (err) {
        console.log(err);
      }
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },
    handleResetForm() {
      this.formExtend.forms.alarmStartRange = [
        moment(new Date()).startOf("day").format("YYYY-MM-DD HH:mm:ss"),

        moment(new Date()).endOf("day").format("YYYY-MM-DD HH:mm:ss"),
      ];
      this.formExtend.forms.comparyName = "";
      this.formExtend.forms.alarmNameType = "";
      this.formExtend.forms.alarmStatus = "";
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },
    //导出
    handleExportClick() {
      let param = "";
      if (
        this.formExtend.forms.alarmStartRange !== null &&
        this.formExtend.forms.alarmStartRange !== ""
      ) {
        param += "&alarmBeginTime=" + this.formExtend.forms.alarmStartRange[0];
        param += "&alarmFinishTime=" + this.formExtend.forms.alarmStartRange[1];
        param +=
          "&comparyName=" +
          (this.formExtend.forms.comparyName == undefined
            ? ""
            : this.formExtend.forms.comparyName);
        param +=
          "&alarmNameType=" +
          (this.formExtend.forms.alarmNameType == ""
            ? 0
            : this.formExtend.forms.alarmNameType);
        param +=
          "&alarmStatus=" +
          (this.formExtend.forms.alarmStatus == ""
            ? 0
            : this.formExtend.forms.alarmStatus);
        param += "&userId=" + 1;
        document.location.href = this.exportUrl + param;
      } else {
        this.$message({
          showClose: true,
          message: "开始时间与结束时间不能为空！",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.links {
  color: #0000ff;
  cursor: pointer;
}

/deep/ .el-button--primary {
  .e6-icon-export_line,
  .e6-icon-set-up_line {
    color: #fff !important;
  }
}
</style>
